import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    icon: {
      fontSize: theme.typography.pxToRem(20),
    },
  }),
  { name: 'GenerationToolsIcons' }
);
